interface Props {
  size?: number
  color?: string
  /** Background circle color. Set to "transparent" to omit. */
  background?: string
  /** Stroke width in SVG units (0-100 viewport). Default 1.5. */
  stroke?: number
  className?: string
  ariaLabel?: string
}

/**
 * Pelabuhan compass rose — 8-point stylized navigational rose.
 *
 * Cardinal (N/S/E/W) points are larger diamonds; intercardinal (NE/NW/SE/SW)
 * are smaller. North marked with a filled wedge for instant orientation.
 * Designed to be readable at 16px (favicon) up to 200px (splash hero).
 */
export function CompassRose({
  size = 32,
  color = 'currentColor',
  background = 'transparent',
  stroke = 1.5,
  className,
  ariaLabel = 'Compass',
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={ariaLabel}
    >
      {background !== 'transparent' && <circle cx="50" cy="50" r="48" fill={background} />}

      {/* outer ring */}
      <circle cx="50" cy="50" r="46" fill="none" stroke={color} strokeWidth={stroke} opacity="0.5" />

      {/* intercardinal (smaller diamond points) — NE/SE/SW/NW */}
      <g fill={color} opacity="0.55">
        <path d="M 50 50 L 72 28 L 50 32 Z" />
        <path d="M 50 50 L 72 72 L 68 50 Z" />
        <path d="M 50 50 L 28 72 L 50 68 Z" />
        <path d="M 50 50 L 28 28 L 32 50 Z" />
      </g>

      {/* cardinal — E/S/W (outline only) */}
      <g fill="none" stroke={color} strokeWidth={stroke} strokeLinejoin="round">
        <path d="M 50 50 L 88 50 L 50 54 Z" />
        <path d="M 50 50 L 50 88 L 46 50 Z" />
        <path d="M 50 50 L 12 50 L 50 46 Z" />
      </g>

      {/* North — filled (orientation marker) */}
      <path d="M 50 50 L 50 12 L 54 50 Z" fill={color} />

      {/* center hub */}
      <circle cx="50" cy="50" r="3" fill={color} />
    </svg>
  )
}
